import { render, staticRenderFns } from "./FamilyRelationShipSelect.vue?vue&type=template&id=40c1696a&"
import script from "./FamilyRelationShipSelect.vue?vue&type=script&lang=ts&"
export * from "./FamilyRelationShipSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports